import { render } from "./BillingProfiles.vue?vue&type=template&id=3d8ef002"
import script from "./BillingProfiles.vue?vue&type=script&lang=js"
export * from "./BillingProfiles.vue?vue&type=script&lang=js"

import "./BillingProfiles.vue?vue&type=style&index=0&id=3d8ef002&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__